import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { AuthDataProvider } from '../../providers/auth-data/auth-data';
import { AngularFireAuth } from 'angularfire2/auth';
// import { FcmProvider } from '../../providers/fcm/fcm'

import { HomePage } from '../home/home';
import { RegisterPage } from '../register/register';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  public loginForm: any;
  public AuthSubscription: Subscription;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public authData: AuthDataProvider,
    public afAuth: AngularFireAuth,
    //private toast: ToastController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    // public fcmProvider: FcmProvider
    ) {

    let email_validat = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    this.loginForm = fb.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(email_validat)])],
      password: ['', Validators.compose([Validators.minLength(1), Validators.required])]
    });
  }


  ionViewDidLoad() {
  }

  login() {
    let LoginCredentials = this.loginForm.value;
    let loadingPopupLogin = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    if (!this.loginForm.valid) {
      this.presentAlert('La contraseña no puede estar en blanco')
      console.log("error");
    } else {
      loadingPopupLogin.present();
      this.authData.loginUser(LoginCredentials)
        .then(authData => {
          console.log("Auth pass", authData);
          // this.fcmProvider.saveToken(this.authData.getAuthUser()).then(result => {
          //   this.fcmProvider.registerGlobalToken();
          // })
          this.authData.setUserData().then(() => {
            loadingPopupLogin.dismiss();
            this.navCtrl.setRoot(HomePage);
          });
        }, error => {
          var errorMessage: string = error.message;
          console.log(errorMessage)
          loadingPopupLogin.dismiss().then(() => {
            this.presentAlert("No se pudo verificar tu usuario o contraseña.")
          });
        });
    }
  }

  forgot() {
    let ion = this;
    let prompt = ion.alertCtrl.create({
      enableBackdropDismiss: false,
      title: 'INTRODUCE TU CORREO ELECTRÓNICO',
      message: "Una nueva contraseña va a ser enviada a tu correo eletrónico",
      cssClass: 'alertCustomCss1',
      inputs: [
        {
          name: 'email',
          placeholder: 'tu@ejemplo.com'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
            console.log('Cancelar Clickeado')
          }
        },
        {
          text: 'Enviar',
          handler: data => {
            let loadingPopupForgot = this.loadingCtrl.create({
              dismissOnPageChange: true,
              spinner: 'crescent',
              content: 'Reseteando tu contraseña...'
            });
            loadingPopupForgot.present();

            ion.authData.forgotPasswordUser(data.email).then(() => {
              loadingPopupForgot.dismiss().then(() => {
                ion.presentAlert('CONSULTA TU CORREO ELECTRÓNICO', 'Cambio de contraseña satisfactorio')
              })
            }, error => {
              ion.presentAlert('RESTABLECER CONTRASEÑA', 'Error al restablecer contraseña, correo electrónico incorrecto')
              loadingPopupForgot.dismiss();
            })
          }
        }
      ]
    });
    prompt.present();
  }

  presentAlert(title, message = "") {
    let ion = this;
    let alert = ion.alertCtrl.create({
      title: title,
      message: message,
      cssClass: 'alertCustomCss',
      buttons: ['OK']
    });
    alert.present();
  }

  createAccount() {
    let ion = this;
    ion.navCtrl.push(RegisterPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts